export default function SecondaryNav() {
    return {
        isMobile: window.matchMedia('(max-width: 1024px)').matches,
    }
}